import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LogOut, Loader2 } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { useAudioPlayer } from '../hooks/useAudioPlayer';
import { AUDIOS } from '../data/audios';
import { AudioCard } from '../components/user-area/AudioCard';
export function UserAreaPage() {
  const {
    user,
    isAuthenticated,
    isLoading,
    logout
  } = useAuth();
  const navigate = useNavigate();
  const {
    playingId,
    progress,
    currentTime,
    registerRef,
    togglePlay,
    restartAudio,
    handleTimeUpdate,
    handleAudioEnded,
    pauseAll
  } = useAudioPlayer();
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/area-usuario/login', {
        replace: true
      });
    }
  }, [isAuthenticated, isLoading, navigate]);
  const handleLogout = async () => {
    pauseAll();
    await logout();
    navigate('/area-usuario/login', {
      replace: true
    });
  };
  if (isLoading || !isAuthenticated) {
    return <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center" data-id="element-809">
        <Loader2 className="w-8 h-8 text-gold animate-spin" data-id="element-810" />
      </div>;
  }
  return <div className="min-h-screen bg-[#0A0A0B] font-sans text-white selection:bg-gold/30 selection:text-gold pb-20" data-id="element-811">
      {/* Top Banner */}
      <div className="relative overflow-hidden bg-gradient-to-r from-[#1a1400] via-[#2a1f00] to-[#1a1400] border-b border-gold/40 py-3 px-4 text-center" data-id="element-812">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gold/10 to-transparent animate-shimmer pointer-events-none" data-id="element-813" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.15),transparent_70%)] pointer-events-none" data-id="element-814" />
        <p className="relative z-10 text-gold text-xs sm:text-sm font-black tracking-wide flex items-center justify-center gap-2" data-id="element-815">
          <span style={{
          animation: 'pulseGlow 2s ease-in-out infinite'
        }} data-id="element-816">
            ✨
          </span>
          Este espacio es privado. Aquí es donde ocurre el cambio real.
          <span style={{
          animation: 'pulseGlow 2s ease-in-out infinite'
        }} data-id="element-817">
            ✨
          </span>
        </p>
      </div>

      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0A0A0B]/90 backdrop-blur-md border-b border-white/5 px-4 sm:px-[5%] py-4 flex items-center justify-between" data-id="element-818">
        <div className="font-serif italic text-gold text-lg sm:text-xl font-bold tracking-[2px]" data-id="element-819">
          EL CÓDIGO 888
        </div>
        <div className="flex items-center gap-4 sm:gap-6" data-id="element-820">
          <span className="text-white/60 text-xs sm:text-sm font-medium hidden sm:inline-block" data-id="element-821">
            Hola, {user?.name.split(' ')[0]}
          </span>
          <button onClick={handleLogout} className="flex items-center gap-2 text-white/40 hover:text-white transition-colors text-xs font-bold uppercase tracking-wider" data-id="element-822">
            <LogOut className="w-4 h-4" data-id="element-823" />
            <span className="hidden sm:inline" data-id="element-824">Salir</span>
          </button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 pt-12 sm:pt-20" data-id="element-825">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16" data-id="element-826">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="font-serif text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4" data-id="element-827">
            Tu espacio de <span className="text-gold" data-id="element-828">enfoque y claridad</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-white/60 text-sm sm:text-base max-w-xl mx-auto" data-id="element-829">
            Accede a tus audios y crea tu momento diario de conexión.
          </motion.p>
        </div>

        {/* Audio List */}
        <div className="space-y-4 sm:space-y-6" data-id="element-830">
          {AUDIOS.map((audio, idx) => <AudioCard key={audio.id} audio={audio} index={idx} isPlaying={playingId === audio.id} progressPercent={progress[audio.id] || 0} currentTimeStr={currentTime[audio.id] || '0:00'} registerRef={registerRef} onTogglePlay={togglePlay} onRestart={restartAudio} onTimeUpdate={handleTimeUpdate} onEnded={handleAudioEnded} data-id="element-831" />)}
        </div>
      </main>
    </div>;
}